module.exports = {
  defaultUserObj: {
    user_id: 'not logged in',
  },
  adcContextPrefix: 'tenx.adc',
  analyticTools: {
    gtm: 'gtm',
    hotjar: 'hotjar',
    clarity: 'clarity',
    ga: 'ga',
  },
}
